import { Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { LinkInMessage } from '@components/link_in_message.component';
import { withTranslation } from '@modules/i18n_and_l10n/with_translation';
import styled from 'styled-components';

interface Props {
	textAboutUs: string;
}

const elements = {
	container: styled.div`
		display: flex;
		flex-direction: column;
		gap: ${tokens.spacing.x2};
		background-color: ${tokens.color.bg.surface};
		padding: ${tokens.spacing.x4} ${tokens.spacing.x3};
		width: 100%;
		border-radius: ${tokens.borderRadius.large};

		${tokens.breakpointQuery.small} {
			padding: ${tokens.spacing.x7} ${tokens.spacing.x9};
		}
	`,
};

export function ReceptionHomeAboutUs({ textAboutUs, ...rest }: Props): JSX.Element {
	return (
		<elements.container {...rest}>
			<Text.h3 variant='headingSmall'>{withTranslation('PW.Page.RH.AboutUs')}</Text.h3>
			<Text variant='bodyRegular' preserveLineBreaks>
				<LinkInMessage text={textAboutUs} />
			</Text>
		</elements.container>
	);
}
